import { t } from "@lingui/core/macro";

import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { PunchPassListItem } from "./PunchPassListItem";
import { PunchPassListItem_PunchPass$key } from "./__generated__/PunchPassListItem_PunchPass.graphql";

export type AppliedPunchPassesSectionProps = {
  punchPassRefs: readonly PunchPassListItem_PunchPass$key[];
  onRemove: (id: string) => void;
};

export const AppliedPunchPassesSection = ({
  punchPassRefs,
  onRemove,
}: AppliedPunchPassesSectionProps) => {
  if (punchPassRefs.length === 0) {
    return null;
  }

  return (
    <VStack gap={2} padding={5} backgroundColor="surface-primary">
      <Text
        variant="mainTiny"
        color="text-secondary"
        fontWeight="semibold"
        paddingVertical={1}
      >{t`APPLIED`}</Text>
      {punchPassRefs.map((ref, index) => (
        <PunchPassListItem
          key={index}
          punchPassRef={ref}
          isAvailable={true}
          isApplied={true}
          onApply={() => {}}
          onRemove={onRemove}
        />
      ))}
    </VStack>
  );
};
